import axios, { InternalAxiosRequestConfig } from "axios";

let strBackendServicePort = "8083";

const { protocol, hostname } = window.location;
const constBaseURL = process.env.REACT_APP_BACKEND_URL || `${window.location.protocol}//${window.location.hostname}/api/v1/`;
console.info('Axios creation.');
const http = axios.create({
  baseURL: constBaseURL,
  headers: {
    "Content-type": "application/json"
  },
});

// Interceptor to include the token
http.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem('authToken');
    const userLogin = localStorage.getItem('userLogin');
    if (config.headers) {
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      if (userLogin) {
        config.headers['User-Login'] = userLogin;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Default export for http instance
export default http;